import { useEffect } from 'react';
import { getMUICache, appendStyleSheet, getImageUrl, getImageSize, convertEpochTime, getImageId, fetchAnchorValue /*getImageId,  getListButtonIcon*/ } from '../../common/utils';
// import Box from '@mui/material/Box';
// import Container from '@mui/material/Container';
// import Grid from '@mui/material/Grid';
import { CacheProvider } from '@emotion/react';
// const DEFAULT_PLACEHOLDER = "https://static.toiimg.com/photo/42706777.gif";
import "./webstories.css";
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages,PreloadViewportImages, ImageLoader} from '../../components/IntersectionObserver/imageComponent';

const Card = (props: any) => {
  const { showDateTime, showAuthorName, item, anchorLinksValue } = props;
  AddImageDimensions();
  SetHighPriorityImages();
  PreloadViewportImages();
  ImageLoader();

    useEffect(()=>{
        EagerLoadImages()
    },[]);

  const { hl, au, imageid, pubInfo, upd, wu } = item;
  const cache = getMUICache();
  let styles = require("./webstories.css");
  appendStyleSheet("Webstories", styles);

  // let imageSize = getImageSize(imageid);

  return (
    <CacheProvider value={cache}>
      <div className="commonwebcard cardone">
      <a role="link" aria-label="Next Page" href={(wu?.startsWith('http') ? wu : (wu?.startsWith('/') ? wu : '/' + wu))} target={fetchAnchorValue(anchorLinksValue, (wu?.startsWith('http') ? wu : (wu?.startsWith('/') ? wu : '/' + wu)))}  >
            <div className="contentwrapper">
              <div className="webstroyimgbox">
                {
                    getImageSize(imageid) && <picture>
                        {/* Add multiple source elements for different image sources */}
                        <source media="(min-width: 768px)"  srcSet={getImageUrl(getImageId(imageid), getImageSize(imageid), 206, 387, pubInfo.baseDomain, false, props.CONSTANTS, '8')} />

                        <source media="(max-width: 767px)"  srcSet={getImageUrl(getImageId(imageid), getImageSize(imageid), 156, 286, pubInfo.baseDomain, false, props.CONSTANTS, '8')} />

                        <img alt={hl?.substring(0, 25)} title={hl?.substring(0, 25)} loading="lazy"/>
                    </picture>
                }
              </div>
              <div className="webstoryoverlay">
                <p className="webstysummry">{hl}</p>
                  {showAuthorName && <p className="webstyauthor">{au} </p>}
                <p className="webstdate">{showDateTime ? convertEpochTime(upd, 'updated', "DD MMM YYYY") : ""}</p>
              </div>
            </div>
          </a>
          </div>
    </CacheProvider>
  )
}
export default Card;